module.exports = __webpack_public_path__ + "media/images/MichaelF-5881fa1cb60da30424b2171f0a7c8a32.jpg";